/*先进企业14，优秀企业家16*/
let prjConfig = {
   portalType: '14,16'
};
export default prjConfig